import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NbDialogRef } from "@nebular/theme";
import { Subject } from "rxjs";
import { map, takeUntil } from "rxjs/operators";
import { User } from "../../@core/data/users";
import { UserService } from "../../@core/services/user.service";
import { convertTimestamp } from "../../@core/utils/convertTimestamps.service";
import { Receipt } from "../../models/receipt.model";
import Shop from "../../models/shop.model";

import {
  InvalidFormatError,
  InvalidNumberError,
  NotEnoughUnitError,
  ReadingConfig,
  doReadNumber,
} from "read-vietnamese-number";

@Component({
  selector: "ngx-dialog-print-receipt",
  templateUrl: "dialog-print-receipt.component.html",
  styleUrls: ["dialog-print-receipt.component.scss"],
})
export class DialogPrintReceiptComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  private destroy$: Subject<void> = new Subject<void>();
  @Input() shopId?: string;
  @Input() uid?: string;
  @Input() user?: User;
  @Input() receipt?: Receipt;
  @Input() shop?: Shop;
  @Input() rePrint?: boolean = false;
  @ViewChild("printBtn") printBtn: ElementRef<HTMLElement>;

  loading = false;
  printing = false;
  displayName = "";
  menu = "pos"; //a4 , pos
  isRefLanguage = false;
  showDept: boolean = true;
  isDefault: boolean = true;
  totalAmountText?: string = "";
  totalAmountDebitText?: string = "";
  config = new ReadingConfig();

  constructor(
    protected ref: NbDialogRef<DialogPrintReceiptComponent>,
    private userService: UserService
  ) {}

  ngOnInit() {
    this.isDefault =
      this.shop.code !== "vfood" &&
      this.shop.code !== "daian" &&
      this.shop.code !== "ppd"
        ? true
        : false;

    this.menu = this.user.printReceiptA4 ? "a4" : "pos";

    this.userService
      .getCurrentUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user: User) => {
        if (user && user.uid != this.uid) {
          this.user = user;
          this.uid = user.uid;
          this.shopId = user.shopId ? user.shopId : user.uid;
          this.displayName = user.displayName ? user.displayName : user.email;
        } else {
          this.uid = "anonymous";
          this.shopId = "anonymous";
          this.displayName = "";
        }
      });

    const totalDebit: number =
      this.receipt.lastDebitAmount +
      this.receipt.totalAmount -
      this.receipt.paymentAmount;
    console.log(
      "🚀 ~ file: layout-receipt-a4-ppd.component.ts:80/totalDebit:",
      totalDebit
    );

    const total: number = this.receipt.totalAmount - this.receipt.paymentAmount;
    console.log(
      "🚀 ~ file: layout-receipt-a4-ppd.component.ts:80/total:",
      total
    );
    this.config.unit = ["đồng"];

    try {
      // Start reading
      this.totalAmountDebitText = doReadNumber(
        this.config,
        totalDebit.toFixed(0)
      );
      this.totalAmountText = doReadNumber(this.config, total.toFixed(0));
    } catch (err) {
      // Handle errors
      if (err instanceof InvalidFormatError) {
        console.error("Định dạng input không hợp lệ");
      } else if (err instanceof InvalidNumberError) {
        console.error("Số không hợp lệ");
      } else if (err instanceof NotEnoughUnitError) {
        console.error("Không đủ đơn vị đọc số");
      }
    }
    console.log(
      "🚀 ~ file: layout-receipt-a4-ppd.component.ts:80/totalAmountDebitText:",
      this.totalAmountDebitText
    );

    console.log(
      "🚀 ~ file: layout-receipt-a4-ppd.component.ts:80/totalAmountText:",
      this.totalAmountText
    );
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      if (this.user.printReceiptA4 && this.user.printReceiptPos) {
        //
      } else {
        this.print();
      }
    }, 1000);
  }

  selectMenu(value) {
    this.menu = value;
  }

  cancel() {
    this.ref.close();
  }

  print() {
    this.printing = true;
    let el: HTMLElement = this.printBtn.nativeElement;
    el.click();
    this.ref.close(true);
  }
}
